
import Vue from 'vue';
import Modal from '../components/modal.vue';

export class ModalLoader {
    private instance: any = null;

    public show(    
        title: string,
        message: string,
        okOnly: boolean,
        exec: () => void,
        links:ModalLink[] = [],
        okTitle: string ='OK',
        cancelTitle: string ='Cancel',
        html: string ='',){
            if (this.instance==null) this.initialize();

            this.instance.alertTitle = title;
            this.instance.alertMessage = message;
            this.instance.okOnly = okOnly;
            this.instance.exec = exec;
            this.instance.links = links;
            this.instance.showAlert = true;
            this.instance.okTitle = okTitle;
            this.instance.cancelTitle = cancelTitle;
            this.instance.html = html;
            (this.instance as Vue).$forceUpdate();
            this.sendEvent(title,message,this.instance.$api);                     
    }
    /** OKのみのダイアログを表示し、OKボタンが押されたら後続処理を呼び出します */
    public async showDialog(title: string, message: string, okOnly:boolean = true, okTitle = 'OK', cancelTitle = 'Cancel', html =''){

      return new Promise((resolve,reject) =>{
                  if (this.instance==null) this.initialize();
                  this.instance.$api.closeWaitCursor();                  
                  this.instance.alertTitle = title;
                  this.instance.alertMessage = message;
                  this.instance.okOnly = okOnly;
                  this.instance.exec = resolve;
                  this.instance.cancel = reject;
                  this.instance.showAlert = true;
                  this.instance.links = [];
                  this.instance.okTitle = okTitle;
                  this.instance.cancelTitle = cancelTitle;
                  this.instance.html = html;
                  (this.instance as Vue).$forceUpdate();
                  this.sendEvent(title,message,this.instance.$api);                  
                });
    }
    public sendEvent(title:string, message:string, api:any){
      if (title == '無効な操作' || title == ''){
        // var dataLayer = (window as any).dataLayer;
        // if(dataLayer)dataLayer.push({'event': 'dialog', 'message':message});             
        api.issueGA4eventCommon({'event': 'dialog', 'message':message});
      }
    }
    public initialize(){

        //appの支配下に入れる必要がある
        const parent: Vue = (document.getElementById('app') as any).__vue__;
        var component = new Modal({parent: parent}).$mount();
        document.getElementById('app').appendChild(component.$el);
        this.instance =component;

    }

}

export class ModalLink {
  constructor(text:string, link:string, isExternalLink:boolean=false) {
    this.text = text;
    this.link = link;
    this.isExternalLink = isExternalLink;
  }  
  public text:string = '';
  public link:string = '';
  public isExternalLink:boolean = false;
}

const plugin = {
    install() {
      // フォーマッタの初期化
      const modal = new ModalLoader();
      //formatter.initialize();
  
      //   フォーマッタの注入
      Object.defineProperty(Vue.prototype, '$modal', {
        get() {
          return modal;
        },
      });
    },
  };
  
  export default plugin;